// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2UyjW","rounded":"style_rounded__1m4uZ"};